module.exports = __webpack_public_path__ + "images/assets/7e3aef7d15fe405e40c84afa93e37d3e.svg";